<template>

  <div class="popup_item" v-loading.fullscreen.lock="fullscreenLoading">
    <div>
      <h3 class="joblist_carat_h3">ヤギからのお知らせメェ〜<br>
        <span class="joblist_carat_h3_span">あなたが合格しそうな
          <span class="joblist_carat_h3_word">花</span>
          <span class="joblist_carat_h3_word">形</span>
          <span class="joblist_carat_h3_word">職</span>
          <span class="joblist_carat_h3_word">種</span>
          ランキング
        </span>
      </h3>
      <p class="joblist_carat_link">Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank"
          class="consent-link">利用規約</a>、<a href="https://www.yagish.jp/privacy/" target="_blank"
          class="consent-link">個人情報保護方針</a>、Caratの<a
          href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank"
          class="consent-link">プライバシーポリシー</a></p>
      <p class="joblist_carat_link"><img src="/static/renew_img/check_icon.png" alt="同意する"
          style="height: 20px;">規約に同意して問い合わせる</p>
    </div>

    <div class="carat_block">
      <div v-for="(item, index) in job_list" class="carat_wrap" v-show="!item.is_applicated">
        <a class="carat_link" v-if="item.from_source == 'carat'">
          <div class="joblist_link">
            <div class="flex joblist_link01">
              <p class="txt_category" v-for="(item2, index2) in item.search_result_json.employment_types">{{ item2 }}
              </p>
              <h4 class="joblist_h4">{{ item.search_result_json.title }}</h4>
            </div>
            <div class="joblist_link02">
              <p class="joblist_company">{{ item.search_result_json.company_name }}</p>
              <p class="txt_area">{{ item.search_result_json.work_location }}</p>
              <p class="joblist_salary">{{ item.search_result_json.salary }}</p>
            </div>
            <ul class="flex joblist_keywordlist">
              <li class="joblist_keyworditem" v-for="(item2, index2) in item.search_result_json.job_features">{{ item2
                }}</li>
            </ul>

            <div class="flex joblist_summary">
              <p class="joblist_txt" v-if="true">{{ item.search_result_json.description }}
              </p>

              <img :src="imgitem" v-for="(imgitem, subindex) in item.search_result_json.cover_urls" alt="求人イメージ画像"
                v-if="subindex == 0" class="joblist_img">
            </div>

            <div class="flex joblist_button">
              <button @click="$eventHub.$emit('open-yagiprime-carat-dialog', item)"
                class="joblist_detail_link"><span>詳細を見る</span></button>
              <button type="button" id="pdf-dn-carat-completed"
                @click="applicantYagiprimeCarat(item, 'アルバイト', item.type)"
                class="el-button el-button--success carat_btn"><span>履歴書を提出する</span></button>
            </div>
          </div>
        </a>
        <a class="carat_link" v-else-if="item.from_source == 'box'">
          <div class="joblist_link">
            <div class="flex joblist_link01">
              <h4 class="joblist_h4">{{ item.search_result_json.title }}</h4>
            </div>
            <div class="joblist_link02">
              <p class="joblist_company">{{ item.search_result_json.company_name }}</p>
              <p class="joblist_salary">{{ item.search_result_json.salary }}</p>
            </div>

            <div class="flex joblist_summary">
              <p class="joblist_txt" v-if="true">{{ item.search_result_json.description }}
              </p>

              <img :src="imgitem" v-for="(imgitem, subindex) in item.search_result_json.cover_urls" alt="求人イメージ画像"
                v-if="subindex == 0" class="joblist_img">
            </div>

            <div class="flex joblist_button">
              <button @click="locationBox(item.search_result_json.detail_url)"
                class="joblist_detail_link"><span>詳細を見る</span></button>
            </div>
          </div>
        </a>
      </div>
    </div>

    <yagiprime-carat-dialog />

  </div>
</template>

<style lang="css" src="@/assets/css/renew3_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
/* @import url("//unpkg.com/element-ui@2.15.13/lib/theme-chalk/index.css"); */
</style>
<style scoped>
#renew3_mypage .popup_block {
  text-align: center;
  position: relative;
  z-index: 1;
}

#renew3_mypage .txt02 {
  font-size: 1rem;
  line-height: 1.5;
  margin: 5px 0;
}

#renew3_mypage .txt03 {
  display: inline-block;
  position: relative;
  font-weight: bold;
}

#renew3_mypage .txt03::before {
  position: absolute;
  content: "";
  background: #fff620;
  height: 8px;
  width: 110%;
  bottom: 2px;
  left: -5%;
  z-index: -1;
}

#renew3_mypage .carat_block {
  margin-bottom: 10px;
}

#renew3_mypage .joblist_carat_h3 {
  margin-bottom: 10px;
}

#renew3_mypage .joblist_carat_h3_span {
  font-size: 1rem;
  color: #E95B10;
}

#renew3_mypage .joblist_carat_h3_word {
  display: inline-block;
  color: #fff;
  background: #004d40;
  border-radius: 50px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}

#renew3_mypage .joblist_carat_link {
  font-size: 0.8rem;
}

#renew3_mypage .joblist_link {
  background: #fff;
  padding: 20px;
  margin: 20px 0;
  border-radius: 8px;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.17);
}

#renew3_mypage .carat_link:hover {
  text-decoration: none;
  opacity: 1;
}

#renew3_mypage .joblist_link01 {
  align-items: center;
  margin-bottom: 10px;
}

#renew3_mypage .txt_category {
  background: #0f9934;
  color: #fff;
  border-radius: 50px;
  padding: 2px 10px;
  margin-right: 5px;
  font-size: .65rem;
  font-weight: bold;
  white-space: nowrap;
}

#renew3_mypage .joblist_link02 {
  margin-bottom: 10px;
}

#renew3_mypage .joblist_h4 {
  color: #004d40;
  line-height: 1.4;
  font-size: 1rem;
  font-weight: bold;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

#renew3_mypage .joblist_company {
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 5px;
}

#renew3_mypage .txt_area,
#renew3_mypage .joblist_salary {
  position: relative;
  margin-left: 25px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

#renew3_mypage .txt_area::before {
  position: absolute;
  content: "";
  background-image: url(/txt_area.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 16px;
  height: 16px;
  left: -20px;
  top: calc(50% - 8px);
}

#renew3_mypage .joblist_salary::before {
  position: absolute;
  content: "";
  background-image: url(/joblist_salary.svg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 16px;
  height: 16px;
  left: -20px;
  top: calc(50% - 8px);
}

#renew3_mypage .joblist_keywordlist {
  flex-wrap: wrap;
  margin-bottom: 5px;
}

#renew3_mypage .joblist_keyworditem {
  margin: 0 5px 5px 0;
  border: 1px solid #BFBFBF;
  border-radius: 50px;
  padding: 1px 10px;
  font-size: 0.75rem;
  font-weight: bold;
}

#renew3_mypage .joblist_summary {
  margin-bottom: 10px;
}

#renew3_mypage .joblist_summary .joblist_txt {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 0.8rem;
  color: #999999;
}

#renew3_mypage .joblist_img {
  width: 100px;
  height: auto;
  object-fit: cover;
  margin-left: 10px;
}

#renew3_mypage .joblist_button {
  align-items: center;
  justify-content: space-between;
}

#renew3_mypage .joblist_detail_link,
#renew3_mypage .carat_btn {
  width: calc(100% / 2 - 5px);
  font-weight: bold;
  background: #fff;
  border: 1px solid #D1345E;
  padding: 12px 0;
}

#renew3_mypage .joblist_detail_link {
  padding: 12px 20px;
  border-radius: 4px;
  color: #D1345E;
}

#renew3_mypage .carat_btn {
  background: #D1345E;
  border-color: #D1345E;
}

#renew3_mypage .consent-link {
  color: #347CD4;
}

#renew3_mypage .consent-txt {
  justify-content: center;
  align-items: center;
}

#renew3_mypage .consent-icon {
  width: auto;
  height: 16px;
  object-fit: cover;
  margin-right: 5px;
}

@media screen and (max-width: 640px) {
  #renew3_mypage .joblist_button {
    display: block;
  }

  #renew3_mypage .joblist_detail_link,
  #renew3_mypage .carat_btn {
    width: 100%;
  }

  #renew3_mypage .joblist_detail_link {
    margin-bottom: 10px;
  }
}
</style>
<style scoped>
#renew3_mypage .sakusei_history {
  background: #fff;
  padding: 15px;
  -webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .25);
  box-shadow: 0 0 4px rgba(0, 0, 0, .25);
  border-radius: 10px;
  margin-bottom: 20px;
}

#renew3_mypage .sakusei_history h3 {
  color: #0f9934;
  font-size: 1rem;
  margin-bottom: 10px;
}

#renew3_mypage .sakusei_history li:before {
  content: "\25CF";
  color: #004d40;
  margin-right: 5px;
}
</style>
<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'

import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'
import YagiprimeCaratDialog from '@/components/YagiprimeCaratDialog'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  props: {
    job_list: {
      type: Array,
      require: true
    },
    joblistKeyword: {
      type: String
    },
    joblistArea: {
      type: String
    },
    search_id: {
      type: String
    }
  },
  components: {
    'yagiprime-carat-dialog': YagiprimeCaratDialog
  },
  data: function () {
    return {
      fullscreenLoading: false,
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible: false,
      username: '',
      useremail: '',
      selectedYagiOfferData: {},
      selectedQuickEmailData: {},
      mypagedata: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions: {
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code: '',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      // job_list: [],
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho'
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    locationBox: function (lnk) {
      location.href = lnk
    },
    getFormatName: function (format_id) {
      for (let p of this.$site.formatsIndex) {
        if (p.id == format_id) {
          return p.title
        }
      }
      for (let p of this.$site.keirekishoFormatsIndex) {
        if (p.id == format_id) {
          return p.title
        }
      }
      return '-'
    },
    applicantYagiprimeCarat: async function (jobitem, occupation, type) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }

      this.isSended = true
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobitem.job_id)
      // formData.append('format_id', this.formatid)
      formData.append('search_id', '')
      formData.append('detail_flag', '')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('type', type)
      formData.append('site_flag', 'r')
      formData.append('dialog_name', 'yagiprime_mypage')
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')

      // if (this.formatid == "rerekisho_part_time") {
      //   formData.append('occupation', 'アルバイト')
      // } else if (this.formatid == "rirekisho_part_time2") {
      //   formData.append('occupation', 'パート')
      // } else if (this.formatid == "rirekisho_job_new" ||
      //   this.formatid == "rirekisho_job_new_single" ||
      //   this.formatid == "internship") {
      //   formData.append('occupation', '大学生')
      // } else {
      //   formData.append('occupation', '正社員')
      // }
      if (jobitem.type == 'other_recommender') {
        formData.append('recommended_job_id', jobitem.other_recommender_recommended_job_id)

      } else {
        formData.append('recommended_job_id', jobitem.recommended_job_id)

      }
      formData.append('occupation', occupation)

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationYagiprimecarat, formData, { timeout: 60000 })
        .then(function (response) {
          jobitem.applied_date = '2024'
          app.$message({
            message: '応募しました。',
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    clickCarat: async function (_item_id) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.search_id = ''
      this.$eventHub.$emit('open-carat-dialog', 'mypage', null, this.joblistKeyword, this.joblistArea, null, 2, _item_id, this.search_id)


    },
    applicantCarat: async function (jobid) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobid)
      formData.append('format_id', 'mypage')
      this.search_id = ''
      formData.append('search_id', this.search_id)
      formData.append('yaginame', this.username)
      formData.append('detail_flag', '')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mypage')
      formData.append('permission_type', 1)
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      if (this.age >= 50 && this.age <= 59) {
        formData.append('keyword', '50代')
      } else {
        formData.append('keyword', this.joblistKeyword)
      }
      formData.append('area', this.joblistArea)

      formData.append('occupation', '正社員')

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationCarat, formData, { timeout: 60000 })
        .then(function (response) {
          // app.nowStep = 3
          // app.isSended = false
          app.$message({
            message: '応募完了しました。',
            type: 'info'
          })
          for (var _key in app.job_list) {
            if (app.job_list[_key].id == jobid) {
              app.job_list[_key].is_applicated = true
            }
          }
          // app.$eventHub.$emit('open-carat-dialog', 'mypage', null, app.joblistKeyword, app.joblistArea, null, 3, jobid, app.search_id)
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    applicantCarat4Confirm: async function (jobid) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!confirm('本当に応募しますか？')) {
        return
      }
      this.$modal.show('caratinput-dialog')

      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobid)
      formData.append('format_id', 'mypage')
      this.search_id = ''
      formData.append('search_id', this.search_id)
      formData.append('yaginame', this.username)
      formData.append('detail_flag', '')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mypage')
      formData.append('permission_type', 1)
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      if (this.age >= 50 && this.age <= 59) {
        formData.append('keyword', '50代')
      } else {
        formData.append('keyword', this.joblistKeyword)
      }
      formData.append('area', this.joblistArea)

      formData.append('occupation', '正社員')

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationCarat, formData, { timeout: 60000 })
        .then(function (response) {
          // app.nowStep = 3
          // app.isSended = false
          app.$message({
            message: '応募完了しました。',
            type: 'info'
          })
          for (var _key in app.job_list) {
            if (app.job_list[_key].id == jobid) {
              app.job_list[_key].is_applicated = true
            }
          }
          // app.$eventHub.$emit('open-carat-dialog', 'mypage', null, app.joblistKeyword, app.joblistArea, null, 3, jobid, app.search_id)
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {

    const app = this
    console.error(app.job_list)
    return


  },
  beforeMount: function () {
  },
  destroyed: function () {
  }
}
</script>
